import { Skeleton } from '../../../Skeleton'

import * as styles from './AITextGenerationFormFieldsSkeleton.module.css'

function AITextGenerationFormFieldsSkeleton() {
  return (
    <>
      <div className={styles.topRow}>
        <Skeleton className={styles.promptSkeleton} />
        <div className={styles.actions}>
          <Skeleton className={styles.aiVoiceInputSkeleton} />
          <Skeleton className={styles.generateButtonSkeleton} />
        </div>
      </div>
      <div className={styles.settings}>
        <Skeleton className={styles.templatesSkeleton} />
        <Skeleton className={styles.toneSkeleton} />
        <Skeleton className={styles.lengthSkeleton} />
        <Skeleton className={styles.checkboxSkeleton} />
      </div>
    </>
  )
}

export default AITextGenerationFormFieldsSkeleton
